// src/config/constants.js

// Configuración de la API externa según nueva documentación - Cambiado a HTTP


export const API_URL = 'https://demo.quattropy.io/server-caja/public/api/caja';
export const API_URL_JUEGO  = 'https://demo.quattropy.io/server/public/api/game';
export const KIOSCO_API_BASE = 'https://test.kiosco.clubcomodin.com/api/v1/cashier';


// export const API_URL = 'https://proinso-juegos.quattropy.net/server-caja/public/api/caja';
// export const API_URL_JUEGO  = 'https://proinso-juegos.quattropy.net/server/public/api/game';
// export const KIOSCO_API_BASE = 'https://kiosco.clubcomodin.com/api/v1/cashier';


// export const API_URL = 'https://local.quattropy.com/proinso-juego/server-caja/public/api/caja';
// export const API_URL_JUEGO  = 'https://local.quattropy.com/proinso-juego/server/public/api/game';
// export const KIOSCO_API_BASE = 'https://kiosco.dev.quattropy.io/api/v1/cashier';
// export const KIOSCO_API_BASE = 'https://local.quattropy.com:8000/api/v1/cashier';

// Headers requeridos según la documentación
export const API_HEADERS = {
  'X-API-Key': 'caja_internal_key_2025',
  'X-Client-ID': 'sistema_caja_interno',
  'Content-Type': 'application/json'
};


// export const API_URL = 'https://cajademo.quattroinversiones.com/server-caja/public/api/caja';


// export const API_URL = 'https://proinso-juegos.quattropy.net/server-caja/public/api/caja';
// export const API_URL_JUEGO  = 'https://proinso-juegos.quattropy.net/server/public/api/game';


 export const TOKEN_KEY = 'auth_token';

 export const USER_KEY = 'user';

export const SELECTED_LOCAL_STORAGE_KEY = 'selectedLocalId';
 
export const AUTH_ERRORS = {
  BIOMETRIC_NOT_SUPPORTED: 'Tu dispositivo no soporta autenticación biométrica',
  BIOMETRIC_ERROR: 'Error en la autenticación biométrica',
  LOGIN_ERROR: 'Error en el inicio de sesión',
  INVALID_CREDENTIALS: 'Credenciales inválidas',
  SESSION_EXPIRED: 'Tu sesión ha expirado',
  NO_TOKEN: 'No se pudo obtener el token inicial',
};

export const AUTH_MESSAGES = {
  LOGIN_SUCCESS: 'Inicio de sesión exitoso',
  BIOMETRIC_SETUP_SUCCESS: 'Acceso rápido configurado correctamente',
  BIOMETRIC_SETUP_PROMPT: '¿Deseas configurar acceso rápido con biométrico/PIN para la próxima vez?',
  SESSION_RESTORED: 'Sesión restaurada automáticamente',
};

interface AppSettings {
 currency: string;
 currencyCode: string; // Added for Guarani symbol
 currencySymbol: string;
 locale: string;
 decimals: number;
 dateFormat: string;
 timeFormat: string;
 apiUrl: string;
 gameApiUrl: string;
}

const settings: AppSettings = {
 currency: 'PYG', // ISO currency code for Paraguayan Guarani
 currencyCode: 'GS', // Custom display code
 currencySymbol: '₲', // Guarani symbol
 locale: 'es-PY',
 decimals: 0,
 dateFormat: 'dd/MM/yyyy',
 timeFormat: 'HH:mm',
 apiUrl: API_URL,
 gameApiUrl: API_URL_JUEGO
};

export const updateSettings = (newSettings: Partial<AppSettings>) => {
 Object.assign(settings, newSettings);
};
export default settings;
